// @ts-nocheck
/* eslint-disable */
export const checkCircleIcon = {
    data: `<svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11" cy="11" r="9" stroke="currentColor" stroke-width="3"/><path d="M7.47803 10.7578L9.97849 13.2582C10.217 13.4968 10.6184 13.4355 10.775 13.1367L13.7389 7.47827" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'check-circle' as const
};